import { fb, validators } from 'form';
export function getSearchAtdwModel(data) {
  const model = fb.group({
    searchkeyword: [data.searchkeyword || '', [validators.Required()], { label: 'SearchKeyword', type: 'text' }]
    // searchType: [data.searchType || '', [validators.Required()],
    //   { label : null, type: 'radioList',
    //     options : [{ name: 'ATDW Name', value: 'atdw_name' }, { name: 'ATDW Id', value: 'atdw_id' }
    //   ], style : { inline : true }}]
  }); 
  return model;
}